import React, { useEffect } from "react";
import YouTube, { YouTubeEvent, YouTubePlayer } from "react-youtube";
import { useIntervalWhen } from "rooks";
import { Media } from "../Shared/Party/PartyConfigData";


export type FanboxMediaList = {
  getItemAt: (time: number) => { media: Media, played: number };
  getItemAfter: (time: number) => { media: Media, wait: number };
  addItems: (media: Media[]) => void;
  mediaArray: Media[];
}

export const CreateFanboxMediaList = (start?: Media[]): FanboxMediaList => {
  const mediaArray = new Array<Media>();
  if (start !== undefined) {
    mediaArray.push(...start);
    mediaArray.sort((a, b) => a.startTime - b.startTime);

   /* mediaArray.forEach((item) => {
      console.log('Media supplied id : ' + item.url + ' length: ' + item.length + ' till: ' + Math.floor((item.startTime - Date.now()) / 1000) + ' till end: ' + Math.floor((item.startTime + item.length - Date.now()) / 1000));
    })*/
  }

  return {
    getItemAt: (time: number) => {
      for (let i = 0; i < mediaArray.length; i++) {
        if (time <= mediaArray[i].startTime) {
          if (i === 0) {
            const wait = mediaArray[i].startTime - time;
            return { media: { mediaType: 'BEFORE', url: '', length: wait, startTime: time }, played: - wait };
          }
          else if (time >= (mediaArray[i - 1].startTime + mediaArray[i - 1].length)) {
            const wait = mediaArray[i].startTime - time;
            return { media: mediaArray[i], played: -wait };
          }
          else {
            const media = mediaArray[i - 1];
            const played = media.startTime + media.length - time;
            return { media: media, played: played };
          }
        }
      }
      const last = mediaArray[mediaArray.length - 1];
      if (time < (last.startTime + last.length)) {
        const played = last.startTime + last.length - time;
        return { media: last, played: played };
      }
      else {
        return { media: { mediaType: 'AFTER', url: '', length: 0, startTime: time }, played: 0 };
      }
    },
    getItemAfter: (time: number) => {
      for (let i = 0; i < mediaArray.length; i++) {
        if (time < mediaArray[i].startTime) {
          return { media: mediaArray[i], wait: mediaArray[i].startTime - time };
        }
      }
      return { media: { mediaType: 'AFTER', url: '', length: 0, startTime: time }, wait: 0 };
    },
    addItems: (media: Media[]) => {
      mediaArray.push(...media);
      mediaArray.sort((a, b) => a.startTime - b.startTime);
    },

    mediaArray: mediaArray
  }

}


export type YouTubePanelProps = {
  playlist: FanboxMediaList;
  availableWidth: number;
  availableHeight: number;
  readyHandler(player: YouTubePlayer): void;
}

/*const outputPlaylist = (playlist : readonly string[]) => {
  console.log("YT Playlist");
  for(var i = 0; i < playlist.length; i++)
  {
    console.log("#" + i + " " + playlist[i]);
  }
  console.log("End Playlist");
}*/

const YouTubePanel_render = ({ playlist, availableWidth, availableHeight, readyHandler }: YouTubePanelProps) => {
  const mediaList = React.useRef<FanboxMediaList>(playlist);
  const [player, setPlayer] = React.useState<YouTubePlayer>();
  const paused = React.useRef<boolean>(false);
  const waiting = React.useRef<number>(-1);
  const currentMedia = React.useRef<null | Media>(null);
  const correctTime = React.useRef<boolean>();
  const listEnd = React.useRef<boolean>(false);
  const playing = React.useRef<boolean>(false);
  const notifyReadyOnCue = React.useRef<boolean>(true);
  const cueOnLoad = React.useRef<boolean>(false);
  const correctOnCue = React.useRef<boolean>(false);
  const videoLoading = React.useRef<boolean>(false);



  const videoLoadFunc = async () => {
    if(videoLoading.current || listEnd.current)
      return;
    //const cueVideo = cueOnLoad.current;
    //if (cueVideo)
     // cueOnLoad.current = false;
    playing.current = false;
    videoLoading.current = true;
    const time = Date.now();
    const checkTime = time - 15000;
    const result = mediaList.current.getItemAfter(checkTime);

    if (result.media.url === '') {
      listEnd.current = true;
     // console.log('Blank Media URL returned from List');
    }
    else if (result.wait > 15000) {
      waiting.current = result.media.startTime;
      currentMedia.current = result.media;
     // console.log("Video Wait Time Returned of " + result.wait);
    }
    else {
      if (player !== undefined) {
       // if (cueVideo)
        //  player.cueVideoById(result.media.url);
        //else
        console.log('Loading Video : ' + result.media.url);
          await player.loadVideoById(result.media.url);
          //console.log('Loading Video : ' + result.media.url);
          currentMedia.current = result.media;
        
      }
      else
      {
        //console.log('Video Player null on video load');
      }
    }
    videoLoading.current = false;
  }

  const stateChange = async (ev: YouTubeEvent<number>) => {
    console.log('YT Event: ' + ev.data);

    if (ev.data === 2) {
      paused.current = true;
      playing.current = false;
      //console.log('Pause detected: Setting pause flags and play flags');
    }
    else if (ev.data === 1) {
      if (notifyReadyOnCue.current) {
        readyHandler(ev.target);
       // console.log('YT Player notifying ready')
        notifyReadyOnCue.current = false;
      }
      _correctPlayer();
      /*else if (paused.current) {
        const time = Date.now();
        const result = mediaList.current.getItemAt(time);
        if (result.media.url === '') {
          listEnd.current = true;
          if (player !== undefined)
            player.seekTo(await player.getDuration() - 1, false);
        }
        else if (result.media.url === currentMedia.current?.url) {
          const seekTime = Math.floor((time - result.media.startTime) / 1000);
          if (player !== undefined)
            player.seekTo(seekTime, true);
        }
        else {
          if (player !== undefined) {
            player.loadVideoById(result.media.url);
            correctTime.current = true;
          }
        }
      }*/
    }
    else if (ev.data === 0 && !videoLoading.current) {
      //console.log('Video End Detected: Requesting new video');
      videoLoadFunc();
    }
    else if (ev.data === 5) {
      //console.log('YT Player notifying ready')
      readyHandler(ev.target);
      notifyReadyOnCue.current = false;
    }
  }

  const _correctPlayer = async () => {
    if(videoLoading.current || listEnd.current)
    {
      //console.log('Correct Player Abort Video Loading')
    }
    else if (currentMedia.current !== null && !notifyReadyOnCue.current) {
      const rt = Date.now();
      const playerTime = (await player?.getCurrentTime()) ?? 0;
      const seekTime = Math.floor((rt - currentMedia.current.startTime) / 1000);
      if (seekTime > currentMedia.current.length) {
        const result = mediaList.current.getItemAt(rt);
        if (result.media.url === '') {
          listEnd.current = true;
          if (player !== undefined)
            player.seekTo(await player.getDuration() - 1, false);
          //console.log('Terminating Player');
        }
        else {
          if (player !== undefined) {
            player.loadVideoById(result.media.url);
            //console.log('Loading New Video: ' + result.media.url);
          }
        }
      }
      else if ((seekTime > (playerTime + 3)) && player !== undefined) {
        //console.log('Correcting Player Time : ' + seekTime);
        player.seekTo(seekTime, true);
      }
      else
      console.log('Correct Player - No Action')
    }
  }

    useIntervalWhen(
      async () => {
        /*if (playing.current) {
          const time = (await player?.getCurrentTime()) ?? 0;
          if (time > 0) {
            if (correctTime.current) {
              _correctPlayer(time);
              correctTime.current = false;
            }
          }
        }*/
      },
      500,

    );

    const onReadyHandler = (ev: YouTubeEvent) => {
      setPlayer(ev.target);
      playing.current = false;
      const time = Date.now();
      const result = mediaList.current.getItemAt(time);
      if (result.media.url === '') {
        console.log('All Media Finished');
        listEnd.current = true;
      }
      else if (result.played < -1000) {
        console.log('On Wait ' + (-result.played));
        waiting.current = result.media.startTime;
        cueOnLoad.current = true;
        currentMedia.current = result.media;
      }
      else {
        ev.target.cueVideoById(result.media.url);
        correctOnCue.current = true;
        currentMedia.current = result.media;
        //readyHandler(ev.target);
      }

    }
    //videoLoadFunc(true); 




    return (<div>
      <YouTube
        opts={{
          width: availableWidth,
          height: availableHeight,
          playerVars: {
            autoplay: 1,
            controls: 0,
            disablekb: 1
          },
        }}
        className="container"
        onReady={(event: YouTubeEvent) => onReadyHandler(event)}
        onStateChange={(ev: YouTubeEvent<number>) => { stateChange(ev); }}
      />


    </div>);
  }

  export const YouTubePanel = React.memo(YouTubePanel_render);